import styled from 'styled-components'
import ArticleCard from './ArticleCard'


const QuadGrid = styled("div")`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(3, 30vh);

    background: #C6BCAB;

    font-family: "Oswald", sans-serif;
    font-weight: 600;
    font-size: 18vh;

    border: 2px solid black;
    line-height: 30vh;


    .THE {
        grid-row: 1;
        grid-column: 1;
        border: inherit;
        font-size: 14vh;
    }
    .Q {
        grid-row: 2;
        grid-column: 1;
        border: inherit;

    }
    .U {
        grid-row: 2;
        grid-column: 2;
        border: inherit;

    }
    .A {
        grid-row: 2;
        grid-column: 3;
        border: inherit;

    }
    .D {
        grid-row: 2;
        grid-column: 4;
        border: inherit;

    }
    .Blank1 {
        grid-row: 1;
        grid-column: 2;
        border: inherit;

    }

    .A1 {
        grid-row: 1;
        grid-column: 3 / 5;
        border: inherit;
    }
    .A2 {
        grid-row: 3;
        grid-column: 1 / 3;
        border: inherit;
    }
    .A3 {
        grid-row: 3;
        grid-column: 3 / 5;
        border: inherit;
    }

`;

const Quad = (props) => {
    let quad = props.quad;
    let a1 = quad[0];
    let a2 = quad[1];
    let a3 = quad[2];
    return (
        <>
            <QuadGrid>
                <div class="THE">THE</div>
                <div class="Q">Q</div>
                <div class="U">U</div>
                <div class="A">A</div>
                <div class="D">D</div>

                <div class="Blank1"></div>
                <div class="Blank2"></div>
                <div class="Blank3"></div>

                <div class="A1">
                <ArticleCard 
                position='right' 
                article_title={a1.article_title}
                article_url={a1.article_url}
                article_byline={a1.article_byline}
                article_image={a1.article_image}>

                </ArticleCard>
                </div>
                <div class="A2">
                    <ArticleCard
                        position='right'
                        article_title={a2.article_title}
                        article_byline={a2.article_byline}
                        article_image={a2.article_image} article_url={a2.article_url}></ArticleCard>
                </div>
                <div class="A3">
                    <ArticleCard
                        position='left'
                        article_title={a3.article_title}
                        article_byline={a3.article_byline}
                        article_image={a3.article_image} article_url={a3.article_url}></ArticleCard>
                </div>
                {/* <div class="A4">    //removed last
                    <ArticleCard
                        position='left'
                        article_title={a4.article_title}
                        article_byline={a4.article_byline}
                        article_image={a4.article_image} article_url={a4.article_url}></ArticleCard>
                </div> */}

            </QuadGrid>

        </>
    )
}

export default Quad;